export default function Loading(props){
    return (
        <div style={props.style} className='flex justify-center items-center w-20 text-center'>
            <div className='inline-block animate-spin rounded-full bg-gradient-to-r from-pubcm1 to-pubcm2 h-20 w-20 border-t-2 border-b-2 border-cyan-700'></div>
        </div>
    );
}